import { Attributes, Rules, ValueObject } from '@singularsystems/neo-core';
import MyAwardsGridConfig from './MyAwardsGridConfig';

export default class MyAwardsConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.StringLength(50)
    public header: string = "";

    @Rules.StringLength(500)
    public subHeader: string = "";

    @Rules.StringLength(50)
    public pendingAwardsTitle: string = "";

    @Rules.StringLength(250)
    public pendingAwardsDateMessageAll: string = "";

    @Rules.StringLength(250)
    public pendingAwardsDateMessageSome: string = "";

    @Rules.StringLength(50)
    public awardResponsesHeader: string = "";

    @Rules.StringLength(250)
    public awardResponsesSubHeader: string = "";

    @Rules.StringLength(500)
    public awardResponsesFooter: string = "";

    @Attributes.ChildObject(MyAwardsGridConfig)
    public grid: MyAwardsGridConfig = new MyAwardsGridConfig();

    // Client only properties / methods
}